<template>
  <svg width="11" height="13" viewBox="0 0 11 13" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path fill-rule="evenodd" clip-rule="evenodd" d="M1 0C0.447715 0 0 0.447715 0 1V9.8C0 11.4569 1.34314 12.8 3 12.8H7.4C9.05685 12.8 10.4 11.4569 10.4 9.8V4C10.4 3.73478 10.2946 3.48043 10.1071 3.29289L7.10711 0.292893C6.91957 0.105357 6.66522 0 6.4 0H1ZM8.4 4.6V4.41421L5.98579 2H5.8V4.6H8.4Z" fill="#F4B7AD"/>
  </svg>
</template>
